// DEPENDENCIES
import React, { useEffect, useState } from 'react';
// COMPONENTS
import SVG from "react-inlinesvg";
import { Dropdown } from "react-bootstrap";
// CUSTOM COMPONENTS
import FormCard from '../../components/FormCard';
import UploadFormModal from './UploadFormModal';
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import * as formService from "../../../services/form/formService";

const FormListingPage = (props) => {
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [forms, setForms] = useState([]);
    const [filteredForms, setFilteredForms] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [formIdToEdit, setFormIdToEdit] = useState(null);

    useEffect(() => {
        loadAllForms();
    }, []);

    useEffect(() => {
        const filtered = [...forms].filter(x => x.name.toLowerCase().includes(searchTerm.toLowerCase()));
        setFilteredForms(filtered);
    }, [searchTerm])

    const loadAllForms = () => {
        formService.getAllForms().then(res => {
            setForms(res);
            setFilteredForms(res);
        }).catch(ex => {
        });
    }

    const handleUploadModalClose = () => {
        setIsUploadModalOpen(false);
        setFormIdToEdit(null);
    }

    return (
        <div className="row">
            <UploadFormModal formIdToEdit={formIdToEdit} refreshForms={loadAllForms} open={isUploadModalOpen} closeModal={handleUploadModalClose} />
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Forms
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Forms
                            </span>
                        </h3>
                    </div>
                    <div className="container mb-15">
                        <div className="d-flex justify-content-between">
                            <div style={{ width: '88%' }}>
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} /> </span>
                                        </span>
                                    </div>
                                    <input
                                        value={searchTerm}
                                        onChange={e => setSearchTerm(e.target.value)}
                                        placeholder="Search for Form"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="name"
                                    />
                                </div>
                            </div>
                            <div style={{ width: '10%' }}>
                                <Dropdown>
                                    <Dropdown.Toggle variant="primary" id="dropdown-basic" style={{ height: 42 }}>
                                        Add Form
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setIsUploadModalOpen(true)}>Upload Form</Dropdown.Item>
                                        <Dropdown.Item href="#/action-2">Create Form</Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item disabled href="#/action-3">Built-In</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid" style={{ padding: '30px 25px' }}>
                        <div className="form-listing-container">
                            {
                                filteredForms.length == 0 ?
                                    <div className="contact-log-block-container w-100">
                                        <div className="user-info-block">
                                            <a className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                No Forms Available
                                            </a>
                                        </div>
                                    </div>
                                    :
                                    filteredForms.map(form => <FormCard
                                        refreshForms={loadAllForms}
                                        key={form.id}
                                        form={form}
                                        updateFormIdToEdit={setFormIdToEdit}
                                        updateEditModalOpen={setIsUploadModalOpen}
                                    />)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    
    )
}

export default FormListingPage;